<script>
  import { onMount, onDestroy } from 'svelte';
  import {sendMessageToNative, listenMessageFromNative} from "./ApptoNativeBridge"

  let pageSendString = `tap_webview_campaign_detail_${location.pathname}`
  pageSendString = pageSendString.replace("/app/apptoweb/campaign", "");


  function backClickEvent(event) {
    event.preventDefault();
    const payload = {
      type: 'BACK_TAP',
      firebase: {
        eventName: 'mng_user_action',
        actionType: pageSendString,
        actionValue: '戻るボタン'
      }
    };

    sendMessageToNative(payload);

    const delayMilliseconds = 300;
    setTimeout(() => {
      history.back();
    }, delayMilliseconds);
  }

  function closeClickEvent() {
    const payload = {
      type: 'CLOSE_TAP',
      closePage: true,
      firebase: {
        eventName: 'mng_user_action',
        actionType: pageSendString,
        actionValue: '×ボタン'
      }
    };
    sendMessageToNative(payload);
    console.log(payload);
  }
  let cleanupListener;

  onMount(() => {
    /**
     * ネイティブからのメッセージを処理するコールバック関数
     * @param {import('./ApptoNativeBridge').NativeMessage} message
     */
    const handleNativeMessage = (message) => {
      // --- ▼▼▼ ここのロジックを書き換える ▼▼▼ ---

      // messageオブジェクトに backButtonClicked プロパティがあり、その値が true かをチェック
      if (message.backButtonClicked === true) {
        console.log('ネイティブからの指示（backButtonClicked）で history.back() を実行します。');
        history.back();
      }

      // --- ▲▲▲ ここまで書き換え ▲▲▲ ---
    };

    // コンポーネントが画面に表示されたら、メッセージのリスニングを開始します。
    cleanupListener = listenMessageFromNative(handleNativeMessage);
  });

  onDestroy(() => {
    // コンポーネントが画面から消えるときに、リスナーを必ず解除して後片付けをします。
    if (cleanupListener) {
      cleanupListener();
    }
  });
</script>

<div class="header">
  <div class="square-button">
    <button on:click={backClickEvent} class="back-button" aria-label="back">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4025_5694)">
          <path d="M20 13H7.828L13.414 18.586L12 20L5 13L4 12L12 4L13.414 5.414L7.828 11H20V13Z" fill="black" />
        </g>
        <defs>
          <clipPath id="clip0_4025_5694">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </button>
  </div>
  <div class="square-button">
    <button on:click={closeClickEvent} class="button" aria-label="close">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4025_2148)">
          <path
            d="M17.586 19L12 13.414L6.414 19L5 17.586L10.585 12L5 6.414L6.414 5L12 10.586L17.586 5L19 6.414L13.414 12L19 17.586L17.586 19Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_4025_2148">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </button>
  </div>
</div>

<style>
  .header {
    display: grid;
    grid-template-columns: 24px 24px;
    justify-content: space-between;
    padding: 59px 24px 15px 24px;
    background: #fff;
  }

  .square-button {
    width: 24px;
    height: 24px;
  }
  .square-button button{
    padding: 0;
  }

  :global(.container-view:has(#app-to-web-header)) {
    overflow: visible;
  }

  :global(.l-main:has(#app-to-web-header)) {
    padding-top: 0;
    overflow: visible;
  }


  :global(#app-to-web-header) {
    position: sticky;
    top: 0;
    z-index: 3;
  }

  :global(#app-to-web-header + #campaign .campaign-inner ) {
    padding-bottom: 64px;
  }



</style>
